<template>
  <div class="flex flex-col mb-4 w-full justify-between bg-beige-academy-200 leading-7 pt-1">
    <div class="uppercase border-b-2 border-grey-academy-150 w-full text-base md:text-lg
    px-3 py-1 flex justify-between items-center">
      <span class="font-bold">{{ instrument.name }} </span>
      <div v-if="!editing && isLogged">
        <button class="hover:text-orange-academy-300" @click="editing = true">
          <edit-icon class="w-3 md:w-4" />
        </button>
        <button class="ml-3 hover:text-orange-academy-300" @click="deleteInstrument">
          <bin-icon class="w-1" />
        </button>
      </div>
      <button class="w-auto bg-orange-academy-300 text-white px-2 lg:px-4 py-0 lg:py-1
      rounded border hover:bg-white hover:text-orange-academy-300
      border-orange-academy-300 text-sm"
        @click="updateInstrument" v-if="editing">
          {{$t('stripe.save')}}
      </button>
    </div>
    <div class="flex flex-col md:flex-row w-full justify-between items-start px-3 py-3"
    v-if="!editing">
      <span>
        {{ instrument.pivot.years }} {{ isTeacher ? $t('skills.teaching-years') :
        $t('skills.practise-years')}}
      </span>
      <span class="w-3/4">
        {{ instrument.pivot.description }}
      </span>
    </div>
    <div class="flex flex-col w-full justify-between items-start px-3 py-3" v-else>
      <div class="flex justify-between items-center mt-5 w-full">
          <label for="course" class="w-1/3">
            {{isTeacher ? $t('skills.teaching-years') : $t('skills.practise-years')}}
          </label>
          <input type="text" id="course" v-model="editedData.years"
          class="border-b-2 w-full p-2 border-grey-academy-150">
          <span class="text-red-500"
            v-if="errors.has('years')"
            v-text="errors.get('years')"
          >
          </span>
        </div>
        <div class="flex flex-col justify-between items-center mt-5 w-full">
          <label for="qualification" class="w-full mb-2">
            {{$t('skills.instrument')}} <br>
            {{$t('skills.why')}} <br>
            {{$t('skills.for')}}
          </label>
          <textarea type="text" id="qualification" v-model="editedData.description"
            class="border-b-2 w-full p-2 border-grey-academy-150" />
          <span class="text-red-500"
            v-if="errors.has('description')"
            v-text="errors.get('description')"
          >
          </span>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Errors from '@/util/Errors';
import BinIcon from './graphics/BinIcon.vue';
import EditIcon from './graphics/EditIcon.vue';

export default {
  components: {
    EditIcon,
    BinIcon,
  },

  props: ['instrument'],

  data() {
    return {
      editing: false,

      editedData: {
        years: this.instrument.pivot.years,
        description: this.instrument.pivot.description,
      },
      errors: new Errors(),
    };
  },

  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
      user: 'auth/user',
    }),

    isLogged() {
      if (this.user && this.isTeacher && this.instrument.pivot.teacher_id
      && this.user.teacher.id === this.instrument.pivot.teacher_id) {
        return true;
      }
      if (this.user && this.instrument.pivot.student_id
      && this.user.student.id === this.instrument.pivot.student_id) {
        return true;
      }
      return false;
    },
  },

  methods: {
    updateInstrument() {
      const userId = this.isTeacher
        ? this.instrument.pivot.teacher_id
        : this.instrument.pivot.student_id;

      axios.put(`/api/${this.isTeacher ? 'teachers' : 'students'}/${userId}/instruments/${this.instrument.id}`,
        this.editedData).then(() => {
        this.$emit('updated');
        this.editing = false;
      }).catch(({ response: { data: { errors } } }) => {
        this.errors.record(errors);
      });
    },

    deleteInstrument() {
      axios.delete(`/api/${this.isTeacher ? 'teachers' : 'students'}/
      ${this.isTeacher ? this.instrument.pivot.teacher_id : this.instrument.pivot.student_id}
      /instruments/${this.instrument.id}`).then(() => {
        this.$emit('updated');
        this.editing = false;
      });
    },
  },

};
</script>
